import { z } from 'zod';

export const PromotionsSchema = z.array(
  z.object({ id: z.string().or(z.number()), name: z.string() })
);

export const TimeSlotsSchema = z.array(
  z.object({
    availablePromotions: z
      .array(
        z.object({
          basePrice: z.number().optional(),
          feeAmount: z.number().optional(),
          id: z.string().or(z.number()),
          leaveTime: z.string().optional().nullable(),
          timeslotReservationId: z.string().optional(),
        })
      )
      .nullable(),
    hasStandardAvailability: z.boolean(),
    isLeaveTimeRequired: z.boolean().nullable(),
    leaveTime: z.string().optional().nullable(),
    serviceId: z.string().or(z.number()).nullable(),
    standardAvailabilityFeeAmount: z.number().nullable(),
    timeSlot: z.string(),
    timeslotReservationId: z.string().optional().nullable(),
  })
);

export const TablesAvailabilitySchema = z.object({
  timeSlots: TimeSlotsSchema,
  promotions: PromotionsSchema,
});

export type TablesAvailabilityType = z.infer<typeof TablesAvailabilitySchema>;
export type TimeSlotsType = z.infer<typeof TimeSlotsSchema>;
export type PromotionsType = z.infer<typeof PromotionsSchema>;
